import { backdropClasses, MenuItem, Select } from "@mui/material";
import React from "react";
import { ReactComponent as CustomIcon } from "assets/icons/selectIcon.svg";
import { useLocation } from "react-router-dom";
import { ReactComponent as Arrow_Down } from "assets/filter/arrow-down.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const Selectinput = ({ value, onchange, options, placeHolder, isError, customStyle = {}, menuStyle = {}, menuItemStyle = {}, showArrowDown = false, useMuiArrow = false, centerOptions = false }) => {
  const location = useLocation();
  const isCartPage = location?.state?.openCart;
  const placeHolderStyle = {
    color: `${isCartPage ? "#000" : "#595959"}`,
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: ".8vw",
  };

  const priorityColors = {
    Urgent: "#FFD700",
    Standard: "#5078C8",
  };

  const textColor = isCartPage ? "#000" : priorityColors[value] || "#fff";
  return (
    <>
      <Select
        labelId="demo-select-small-label"
        id="demo-select-small"
        displayEmpty
        IconComponent={useMuiArrow ? KeyboardArrowDownIcon : isCartPage ? Arrow_Down : CustomIcon}
        value={value}
        onChange={onchange}
        renderValue={(selected) => {
          const sharedStyle = {
            display: "flex",
            alignItems: "center",
            height: "100%", // Ensures vertical centering
            color: textColor,
            fontFamily: "Poppins",
            fontWeight: 500,
            fontSize: ".8vw",
          };
          if (!selected) {
            return <span style={{ ...placeHolderStyle }}>{placeHolder}</span>;
          }
          return <span style={sharedStyle}>{selected}</span>;
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              bgcolor: "white", // Menu background
              color: "black !important", // Default text
              padding: "0px .2vw",
              borderRadius: ".25vw",
              maxHeight: "200px",
              width: `${isCartPage ? "6vw !important" : "11vw !important"}`,
              overflowY: "auto", // enable scroll if needed
              scrollbarWidth: "none", // Firefox
              "&::-webkit-scrollbar": {
                display: "none", // Chrome, Safari
              },
              "& .MuiMenuItem-root": {
                fontFamily: "Karla",
                fontWeight: 400,
                fontSize: ".9vw",
                justifyContent: centerOptions ? "center" : "flex-start",
                textAlign: centerOptions ? "center" : "left",
                "&.Mui-selected": {
                  backgroundColor: `${isCartPage ? "#fff" : "#444444"}`,
                  color: `${isCartPage ? "#000" : "#fff"}`,
                  borderRadius: ".25vw",
                },
                "&.Mui-selected:hover": {
                  backgroundColor: "#444444",
                  color: "white",
                  borderRadius: ".25vw",
                },
                "&:hover": {
                  backgroundColor: "#444444",
                  color: "white",
                  borderRadius: ".25vw",
                },
              },
              ...menuStyle,
            },
          },
        }}
        sx={{
          height: "2.5vw",
          fontFamily: "Poppins",
          fontWeight: 500,
          fontSize: ".8vw",
          width: `${isCartPage ? "6vw" : "11vw"}`,
          height: `${isCartPage && "2vw"}`,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: `${isCartPage ? "black" : "white"}`,
            // border: `${isCartPage ? "0.5px solid black" : "0.5px solid white"}`,
            border: isCartPage ? "0.5px solid black" : isError ? "0.5px solid #F23D3D" : "0.5px solid white",

            borderRadius: ".25vw ",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: `${isCartPage ? "black" : "white"}`,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: `${isCartPage ? "0.5px solid black" : "0.5px solid white"}`,
            // outline: "none",
          },
          "& .MuiSelect-icon": {
            top: "50%",
            transform: "translateY(-50%)",
            right: isCartPage ? "0.3vw" : "0.5vw",
            color: useMuiArrow ? "#000 !important" : isCartPage ? "#000" : "#fff",
            width: "1.2vw",
            height: "1.2vw",
            transition: "transform 0.3s ease",
          },
          "& .MuiSelect-iconOpen": {
            transform: "translateY(-50%) rotate(180deg)",
          },
          background: isError ? "#F23D3D08" : "transparent",
          ...customStyle,
        }}
      >
        {options.map((option) => {
          const label = typeof option === "string" ? option : option.label;
          const icon = typeof option === "string" ? null : option.icon;

          return (
            <MenuItem key={label} value={label} sx={{ ...menuItemStyle }}>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5vw",
                  width: icon && centerOptions ? "6.5vw" : "auto",
                  justifyContent: "flex-start",
                }}
              >
                {icon} {label}
              </span>
            </MenuItem>
          );
        })}
      </Select>
    </>
  );
};

export default Selectinput;
